import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import _, { chain, partial, split, isEmpty } from 'lodash';

import { routes } from '../../routes';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { APPLICATION_ID, IGRAAL_ID, IGRAAL_EXTERNAL_REDIRECT_URL } from '../../constants';
import {
    IGRAAL_ALLOWED_PATHS,
    PATH,
    REDIRECT_AFTER_LOGIN_ALLOWED_PATH
} from '../../constants/path';

import {
    registerAdBlockerDetection,
    registerCookieDetection
} from '../../services/adblocker/actions';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { fetchEbonPartners } from '../../services/ebon/actions';

import {
    catchClickId,
    catchRedirectUri,
    catchScoreHash,
    catchUserId,
    catchSource
} from '../../utils/plebicardUtils';
import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const {
            location: { search, pathname }
        } = this.props;

        const values =
            search &&
            chain(search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();

        const redirectUri = values && values.redirect_uri;
        const label = values && values.label;
        const userId = values && values.userId;
        const clickId = values && values.clickId;
        const score = values && values.score;
        const hash = values && values.hash;
        const source = values && values.source;

        catchScoreHash(score, hash);
        catchSource(source);

        // For iGraal: only "My gift cards" is accessible, redirect any other page to the external site
        if (APPLICATION_ID === IGRAAL_ID && !this.isIgraalAllowedPath(pathname)) {
            window.location.replace(IGRAAL_EXTERNAL_REDIRECT_URL);
            return;
        }

        catchRedirectUri(redirectUri, label);
        catchUserId(userId);
        catchClickId(clickId);
        this.redirectToPathname();
    }

    componentDidMount() {
        const { fetchPartnersIfNeeded, fetchCategoriesIfNeeded, fetchEbonPartners } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (prevProps.location !== location) {
            this.changeCurrentLocaleIfNeeded(this.props);
        }

        // For iGraal: redirect any navigation to a disallowed page (including back/forward) to the external site
        if (
            APPLICATION_ID === IGRAAL_ID &&
            prevProps.location.pathname !== location.pathname &&
            !this.isIgraalAllowedPath(location.pathname)
        ) {
            window.location.replace(IGRAAL_EXTERNAL_REDIRECT_URL);
            return;
        }

        /* 
            When going back from Monetico page to merchant card using Browser'back button,
            Monetico scripts are not reloading themselves, which cause a blank page
            For now, we reload the page to force the reset.
        */
        if (
            prevProps.location.pathname.includes(PATH.EBON_VALIDATION_PATH) &&
            location.pathname.includes(PATH.MERCHANTPAGE_EBON_PATH)
        ) {
            window.location = `${location.pathname}${location.hash ? location.hash : ''}`;
            window.location.reload(true);
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, locale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== locale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    isIgraalAllowedPath = pathname => {
        return IGRAAL_ALLOWED_PATHS.some(path => pathname.includes(path));
    };

    redirectToPathname = () => {
        const {
            location: { pathname },
            history
        } = this.props;
        if (REDIRECT_AFTER_LOGIN_ALLOWED_PATH.some(path => pathname.startsWith(path))) {
            history.push(pathname);
        }
    };

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token),
        isAuthFetching: state.authentication.fetching
    };
};

const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchEbonPartners,
    fetchCategoriesIfNeeded,
    changeCurrentLocale,
    registerAdBlockerDetection,
    registerCookieDetection
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js